<template>
  <div>
    <h2 class="mb-2 text-20 text-balance font-medium">
      {{
        /* translators: Primary heading shown if a transactions was blocked */
        $t('lemonsqueezy_checkout.transaction_blocked_title')
      }}
    </h2>
    <p class="text-balance" v-html="/** nosemgrep. trusted translated content */ localizedMessage" />
  </div>
</template>

<script setup>
import { computed } from 'vue'

// eslint-disable-next-line import/extensions
import { trans } from '@/Translate'

const localizedMessage = computed(() => {
  /* translators: Blocked transaction explanation */
  return trans('lemonsqueezy_checkout.transaction_blocked_description', {
    supportLink: `<a
                    href="https://www.lemonsqueezy.com/help"
                    target="_blank"
                      class="text-wtf-majorelle hover:underline"
                    >https://www.lemonsqueezy.com/help</a>`,
  })
})
</script>
